
<template>
  <a :href="item.link">
    <v-card  flat class="ma-2">
      <v-img :src="img" aspect-ratio="1.3"  />
      <v-card-text class="text-xs-center">
        <span class="display-18 black--text">{{ item.name }}</span>
      </v-card-text>
    </v-card>
  </a>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    img: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style scoped>

.reference {
  height: 46px;
  background: #f6f7f9;
  display: flex;
  align-items: center;
  justify-self: flex-end;
}
a {
  text-decoration: none;
}
.tip-container {
  width: 298px;
  height: 286px;
}

.section-tips .section-tips-item .v-card .v-card__text,
#section-tips .section-tips-item .v-card .v-card__text {
  background-color: #eceff1;
  text-align: right;
  height: 80px;
}
.section-tips .section-tips-item .v-card {
  background-color: transparent;
}

.section-tips .section-tips-item .v-card .v-card__text a,
#section-tips .section-tips-item .v-card .v-card__text a {
  color: #000;
}

@media only screen and (min-width: 600px) {
  .section-tips .section-tips-item .v-card .v-card__text,
  #section-tips .section-tips-item .v-card .v-card__text {
    height: 80px;
    border-radius: 5px;
    padding: 10px;
  }
}

@media screen and (max-width: 400px) {
  .section-tips .section-tips-item .v-card .v-card__text,
  #section-tips .section-tips-item .v-card .v-card__text {
    padding: 5px;
    line-height: 18px;
  }
}
</style>
